export enum ContentTypeName {
  ALL = 'todos',
  PERIODIC = 'revistas',
  BOOK = 'livros',
  VIDEO = 'videos',
  CODE = 'codigos',
  NEWSLETTER = 'informativos',
  LEGISLATION = 'legislacao-comentada'
}
